import { render, staticRenderFns } from "./export-2.vue?vue&type=template&id=983881ec&"
import script from "./export-2.vue?vue&type=script&lang=js&"
export * from "./export-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports